import { ClassProvider } from '@angular/core';
import { AggregatorAdapter, AggregatorRoutesApiService } from '../services';

export function provideAggregatorApi(): ClassProvider {
  return {
    provide: AggregatorAdapter,
    useClass: AggregatorRoutesApiService,
  };
}
